import { render, staticRenderFns } from "./customer_add.vue?vue&type=template&id=5b2aa566&scoped=true&"
import script from "./customer_add.vue?vue&type=script&lang=js&"
export * from "./customer_add.vue?vue&type=script&lang=js&"
import style0 from "./customer_add.vue?vue&type=style&index=0&id=5b2aa566&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2aa566",
  null
  
)

export default component.exports